import type { SilaeLocationsSchema } from '@libs/data-access/entities'
import type { UseAppQueryOptions } from '@libs/data-access/queries'
import { useQuery } from '@tanstack/react-query'

import { fetchSilaeLocations } from '../silae.locations.api'
import { silaeLocationsCacheKeys } from '../silae.locations.cacheKeys'

export const useFetchSilaeLocations = (
  queryOptions?: UseAppQueryOptions<SilaeLocationsSchema[]>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: silaeLocationsCacheKeys.get_silae_location(),
    queryFn: () => fetchSilaeLocations()
  })
}
